export const FSL_CUSTOM_MODEL_IMAGE_MAX_COUNT = 3;
export const STANDARD_MODEL_MIN_LABELLED_COUNT = 10;
export const FSL_GROUPED_CUSTOM_MODEL_IMAGE_PAGE_SIZE = 20;
